"use client"
import getYouTubeID from 'get-youtube-id';
import YT from 'react-youtube';
import styles from "./YouTube.module.css";

//#region [Props]
type YouTubeProps = {
    value: {
        _key: string;
        _type: string;
        url: string
    }
}
//#endregion

//#region [Component]
export default function YouTube({ value }: YouTubeProps) {
    const { url } = value;
    if (!url) {
        return null;
    }

    const ytId = getYouTubeID(url);
    if (!ytId) {
        return null;
    }

    return <YT className={styles.YTStyled} videoId={ytId} />
};
//#endregion